<!-- <div>
    <mat-table [dataSource]="requestorData">
        <ng-container matColumnDef="created_at">
            <mat-header-cell *matHeaderCellDef> Created at </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element?.created_at}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef> Purpose </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element?.value}} </mat-cell>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </mat-table>
</div> -->

<div>
    <table mat-table [dataSource]="requestorData" class="mat-elevation-z8">
        <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef> Created At </th>
            <td mat-cell *matCellDef="let element"> {{ element?.created_at | date:"dd MMM, yyyy" }} </td>
        </ng-container>

        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef> Purpose </th>
            <td mat-cell *matCellDef="let element"> {{ element?.value }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    
</div>
